import { createAction, props } from "@ngrx/store";

const prefix = "[Consultant-Skill Effect]";

export const requestUserAndSkills = createAction(
  `${prefix} Request User Skills From Server`,
);

export const requestUserSkillsBuildTeamChain = createAction(
  `${prefix} Request User Skills From Server Build Team Chain`,
  props<{ teamName: string }>(),
);
